<template> 

  <div class="container pt-4 mb-5">
     
    <div>

      <b-row align-v="top">

        <b-col lg="7">

          <b-row align-v="center">
  
            <b-col lg="12">
     
              <div class="mt-4">
 
                <div class="mt-3">

                  <label>Obraz z osobą/osobami:</label>

                  <b-input-group>

                  <b-input-group-prepend> 
                    <img :src="imageUrl" style="max-height: 48px;
                        max-width: 48px;
                        border-radius: 5px;
                        margin-right: 5px; cursor: pointer;" v-if="imageUrl && validateImageUrl(imageUrl)" @click="showImagePreview = !showImagePreview"/>
                  </b-input-group-prepend>
                    <b-form-input v-model="imageUrl" size="lg" ref="imageUrl" placeholder="https://adres.pl/plik.jpg"></b-form-input>
                    
                    <b-input-group-append>
                      
                        <b-button variant="outline-success" @click="triggerFileUpload">
                          <span class="material-symbols-outlined align-middle">
                            file_upload
                          </span>
                          Z pliku
                        </b-button>
                        <input type="file" ref="fileInput" style="display: none;" @change="handleFileUpload" />  
 
                    </b-input-group-append>

                  </b-input-group>

                </div>
          

                <div class="" v-if="showImagePreview && imageUrl">

                  <img :src="imageUrl"  
                    style="max-height: 200px;
                       max-width: 200px;
                       border-radius: 5px;
                       margin-right: 5px;" 
                    v-if="validateImageUrl(imageUrl)" />

                  <div class="small" 
                     style="display: inline-block; margin-left: 10px; vertical-align: top; cursor: pointer;" 
                     @click="imageUrl = ''">
                    <span class="material-symbols-outlined align-middle">
                    close
                    </span> Usuń
                  </div>

                </div>


                <div class="d-none">

                  <label>Wpisz prompt do filmu:</label>

                  <b-input-group>

                    <b-form-input v-model="prompt" size="lg" ref="prompt" placeholder=""></b-form-input>
                    
                  </b-input-group>
    
                </div>
 
              </div>

            </b-col>
 
        </b-row>
    
        <b-row align-v="center" class="mt-2" style="min-height: 40px;">
 
          <b-col lg="6">

            <div class="mt-2" v-if="isAiGenVideo">
              <span class="material-symbols-outlined align-middle rotating">
              rotate_right
              </span> Trwa generowanie video...
            </div>

          </b-col>

          <b-col lg="6">
          
            <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
              <span class="material-symbols-outlined align-middle">
                bolt
              </span>
              Generuj
            </b-button> 
 
          </b-col>

        </b-row>
 
      </b-col>

      <b-col lg="5">

        <div v-if="videoUrl" class="mt-4">

          <label>Wygenerowane video:</label>

          <video :src="videoUrl" controls class="mt-3" style="max-height: 100%; max-width: 100%; border-radius: 5px;" autoplay></video>
                  
        </div>

        <div v-if="videoList" class="mt-4">

          <label>Lista video:</label>
     
           <b-list-group>
            
            <b-list-group-item 
              v-for="(video, index) in videoList" 
              :key="index" 
              @click="videoUrl = video.video_url"
              class="small"
              :class="{ 'disabled': video.status !== 'ready', 'bold': (videoUrl !== '' && (videoUrl === video.video_url)) }"
              style="cursor: pointer;"
            >
            <i class="material-symbols-outlined align-middle mr-2 small rotating" v-if="video.status === 'queue'">rotate_right</i>
            <i class="material-symbols-outlined align-middle mr-2 small" v-if="video.status === 'ready'">check</i>
            <i class="material-symbols-outlined align-middle mr-2 small" v-if="video.status === 'failed'">close</i>
            
              {{ video.task_id }}
              
              <a :href="video.video_url" target="_blank" class="ml-2 text-primary small float-right" v-if="video.status === 'ready'">
                
                <i class="material-symbols-outlined align-middle mr-2 small">download</i>
                
              </a>

            </b-list-group-item>
           
          </b-list-group>

        </div>

        

      </b-col>
    
    </b-row>

    </div>
 
    

    
  </div>

</template>

<script>

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        result: "",
        result2: "",
        selectedText: '',
        windowImageGeneration: false,
        showAdditSett: false,
        isAiGenImg: false,
        isAiGenVideo: false,
        imagePrompt: "",
        query: "",
        prompt: "Ożyw osoby na zdjęciu, niech poruszają się, mówią i gestukulują, niech się normalnie poruszają i uśmiechają naturalnie, twarze zwrócone do kamery",
        videoCredits: 0,
        showImagePreview: false,
        imageUrl: "",
        videoUrl: "",
        videoList: [
        ],
        duration: 5,
        ratio: "720:1280",  
        selectedCameraStyles: "",
        selectedLightStyles: "",
        selectedCameraMovments: "",
        selectedTransformsStyles: "",
        selectedMovieStyles: "",
      }
    },
    methods: {

      validateImageUrl: function(url) {
        if (!url) return false;
        try {
          const imageUrlPattern = /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif|webp|svg))$/i;
          return imageUrlPattern.test(url);
        } catch (error) {
          return false;
        }
      },
 
      getVideos: function() {

        this.axios.get(window.API_URL + "apps/checkVideos",   { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          this.axios.get(window.API_URL + "apps/getVideos",   { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          this.videoList = data

          }).catch(function() {

          })
         
        }).catch(function() {

        })
 
      },
      
        
      generateFinish: function() {
 
        if(!this.imageUrl) {

          this.$bvToast.toast('Dodaj obraz startowy, albo stwórz nowy z AI', {
            title: 'Błąd',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
          })

          return false;
        }

        if(!this.prompt) {
          
          this.$bvToast.toast('Podaj prompt do video', {
            title: 'Błąd',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
          })

          return false;
        }
        
        this.isAiGenVideo = true

        this.showImagePreview = false
        this.videoUrl = ''
        this.$refs.generatePost.disabled = true
        
        this.result = ""
        
        var query = this.prompt;
      
        if(this.selectedCameraStyles) query += ". Styl kamery: " + this.selectedCameraStyles;
        if(this.selectedLightStyles) query += ". Styl oświetlenia: " + this.selectedLightStyles;
        if(this.selectedCameraMovments) query += ". Ruch kamery: " + this.selectedCameraMovments;
        if(this.selectedTransformsStyles) query += ". Styl transformacji: " + this.selectedTransformsStyles;
        if(this.selectedMovieStyles) query += ". Styl filmu: " + this.selectedMovieStyles;
        
 
        query = "Przetłumacz na angielski: '" + query + "'"; 
  
        this.axios.post(window.API_URL + "apps/logVideo/", { 'prompt': this.prompt, 'img': this.imageUrl }, { withCredentials: true, timeout: 3000000 });
  

 
        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
    
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

        
          this.axios.post(window.API_URL + "apps/generateVideo", { 'mode': 'alive', 'prompt': data.result, 'image': this.imageUrl, 'duration': this.duration, 'ratio': this.ratio }, { withCredentials: true, timeout: 3000000 }).then((response) => {

            let data = response.data
            
            if(data.redirectTo) {

              top.location.href = data.redirectTo;

            }
            
            window.scrollTo(0, 0);

            this.$bvToast.toast('Utworzone video znajdzie się na liście po prawej stronie', {
              title: 'OK',
              solid: true,
              toaster: 'b-toaster-top-center',
              variant: 'success',
            })


            this.$refs.generatePost.disabled = false
            this.isAiGenVideo = false

          }).catch(function() {

            this.$refs.generatePost.disabled = false
            this.isAiGenVideo = false

          })

        });

 
      },

      handleFileUpload: function(event) {

        const file = event.target.files[0];
        
        this.uploadedFileUrl = "";
        this.showImagePreview = false

        if (file) {
 
          const formData = new FormData();

          formData.append('file', file);

          const headers = {'Content-Type': 'multipart/form-data'};

          this.axios.post("https://soft.funnelstar.io/api/images/upload/", formData, {
            withCredentials: true,
            headers
          }).then((response) => {

            let data = response.data

            this.uploadedFileUrl = data.file

            if (this.uploadedFileUrl) {

              this.imageUrl = this.uploadedFileUrl

            }

            this.$refs.fileInput.value = null;

          }).catch(function () {

             

          });


        }  

      },

      triggerFileUpload: function() {
        this.$refs.fileInput.click();
      },

      

    },
    computed: {
  
    },
    created() {

      this.getVideos()

      setInterval(() => {
        this.getVideos()
      }, 5000)
 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
 
      @keyframes rotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      .rotating {
        display: inline-block;
        animation: rotate 2s linear infinite;
      }
    </style>